export const EStoreServiceType = {
  Delivery: 0,

  Local: 1,

  Both: 2,
} as const

export type EStoreServiceType = (typeof EStoreServiceType)[keyof typeof EStoreServiceType]
